import React, { useState } from "react";

// import { Form, Input, DatePicker } from "antd";
import { Form, Input } from "antd";

// import { Tabs, Popconfirm, Button, Modal, message, Spin } from "antd";
import {Button, Modal, message, Spin } from "antd";

import { UserAddOutlined } from "@ant-design/icons";
import axios from 'axios'
import ClienteDetail from './ClienteDetail'


// const { Search } = Input;


// const { TabPane } = Tabs;


export default function NewClient(props) {

  const [form] = Form.useForm();
  const [visible, setVisibile] = useState(false);
  const [existingUser, setExistingUser] = useState(false);
  const [loading, setLoading] = useState(false);


  form.resetFields();
  async function fetchOneCliente(id) {
    const client = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/clienti/GetById?id=${id}`)
    return client.data.hits[0];
  }


  // const handleSubmit = () => {
  //   form.submit()
  // }

  // parsing the dates to a moment object for the datepicker


  async function onCardIdChange(e) {


    let cardId = e.target.value

    if (cardId.startsWith('04')) {

      if (cardId.length === 5) {
        console.log('basic client id')
        // look for the card
        // open the details about this client
      }

      if (cardId.length >= 7) {
        console.log('read from the card reader')
        cardId = cardId.substring(2, cardId.length)
        openDetail(cardId)
      }
    } else {

      if (cardId.length >= 5) {
        openDetail(cardId)
      }
    }
  }


  async function openDetail(cardId) {
    setLoading(true)
    let client = await fetchOneCliente(cardId)

    if (client === undefined) {
      message.error('questa carta sembra di non esistere')
    }

    setLoading(false)
    setExistingUser(client)
    setVisibile(false)

  }

  function updateCliente(client) {

    axios
      .put(
        `${process.env.REACT_APP_SERVER_URL}/api/clienti?id=${existingUser._id}`,
        existingUser._source
      )
      .then(
        (response) => {

          if (response.status === 200) {
            message.success("cliente aggiornato con successo");
            setVisibile(false)
            setExistingUser(false)
          }
        },
        (error) => {
          message.error("errore nell'aggiornamento del cliente");
        }
      );
  }

  return (


    <div>

      <div id="new_client">
        <Button type="primary" onClick={() => setVisibile(true)}>
          <UserAddOutlined />
            Associa una carta a un cliente
          </Button>
      </div>

      <Modal width={"80vw"} title="Aggiornare dati del cliente" visible={existingUser} onOk={() => setExistingUser(false)} onCancel={() => setExistingUser(false)}>
        {existingUser && <ClienteDetail key={existingUser.cardId} cliente={existingUser} clientAction={updateCliente} role={props.role} negozio={props.negozio} />}
      </Modal>

      <Modal
        width={"50vw"}
        title="Aggiungi nuovo utente"
        visible={visible}
        onOk={() => setVisibile(false)}
        onCancel={() => setVisibile(false)}
        footer={[
          <Button key="1" onClick={() => setVisibile(false)}>
            Torna indietro
              </Button>,

        ]}
      >

        <Form form={form} style={{ display: "flex", justifyContent: "center" }}>
          <div className="modal_inputs">
            <Form.Item
              placeholder="Basic usage"
              name="cardId"
              label="Numero Card"
              rules={[
                { required: "true", message: "la carta è obbligatoria" },
                { min: 5, message: "la carta deve contenere almeno 5 caratteri" },
                { max: 8, message: "la carta puo contenere al massimo 8 caratteri" },
                { pattern: new RegExp(/^\d+$/), message: "solo numeri sono accettati" }
              ]}
              onChange={onCardIdChange}
            >
              <Input size="large" disabled={loading} />
            </Form.Item>

            {loading &&
              <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}> <Spin />
                <p style={{ textAlign: 'center' }}> Sto cercando questa carta ... </p>
              </div>}
          </div>
        </Form>
      </Modal>
    </div>
  )
}